import type { ReservableRoom, RoomStatus } from './types.js';

export const resolveRoomStatus = (
  shortName: string,
  availability: Map<string, ReservableRoom>,
): RoomStatus => {
  const availableRoom = availability.get(shortName);

  if (!availableRoom || availableRoom.score === 0) {
    return 'unavailable_and_occupied';
  }

  if (availableRoom.score === 1) {
    return 'unavailable_and_free';
  }

  if (availableRoom.score === 2) {
    return 'available_and_occupied';
  }

  return 'available_and_free';
};

export const buildStatusMap = <T>(
  rooms: T[],
  getRoomId: (room: T) => string,
  getShortName: (room: T) => string,
  availability: Map<string, ReservableRoom>,
): Record<string, RoomStatus> => {
  const statusByRoomId: Record<string, RoomStatus> = {};

  for (const room of rooms) {
    const roomId = getRoomId(room);
    const shortName = getShortName(room);
    statusByRoomId[roomId] = resolveRoomStatus(shortName, availability);
  }

  return statusByRoomId;
};
